import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ShieldCheck } from 'lucide-react';
export function PricingSection() {
  const handleCTAClick = () => {
    window.location.href = 'https://cuerpoencalma.it.com/cart/49295445262573:1';
  };
  return <section id="pricing" className="py-24 px-4 bg-cream-100" data-id="element-25">
      <div className="max-w-3xl mx-auto" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-xl overflow-hidden border border-cream-200" data-id="element-27">
          <div className="bg-terracotta p-3 text-center text-white text-sm font-medium tracking-wide" data-id="element-28">
            OFERTA ESPECIAL DE LANZAMIENTO
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-29">
            <h2 className="text-3xl md:text-4xl font-bold text-brown mb-4" data-id="element-30">
              Reset de Hinchazón 7 Días
            </h2>
            <p className="text-brown-light mb-8" data-id="element-31">
              Acceso inmediato al PDF. Lo compras una vez y lo repites cuando
              sientas que vuelves al caos.
            </p>

            <div className="flex justify-center items-center gap-4 mb-8" data-id="element-32">
              <span className="text-3xl font-bold text-brown-light/40 line-through" data-id="element-33">
                $19.99
              </span>
              <span className="text-5xl font-bold text-terracotta" data-id="element-34">$7.36</span>
              <span className="text-brown-light/60" data-id="element-35">USD</span>
            </div>

            <div className="inline-block bg-sage/20 text-sage-dark px-4 py-2 rounded-full text-sm font-semibold mb-6" data-id="element-36">
              ¡Ahorra 63% por tiempo limitado!
            </div>

            <Button fullWidth className="text-xl py-6 mb-6" onClick={handleCTAClick} data-id="element-37">
              Quiero el Reset de 7 Días
            </Button>

            <div className="flex items-center justify-center gap-2 text-sm text-brown-light/70" data-id="element-38">
              <ShieldCheck size={16} data-id="element-39" />
              <span data-id="element-40">Pago seguro y descarga inmediata</span>
            </div>
          </div>

          <div className="bg-cream-50 p-6 text-center border-t border-cream-200" data-id="element-41">
            <p className="text-brown italic" data-id="element-42">
              "Si hoy te aprieta la ropa y estás cansada de adivinar… haz el
              reset."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}